import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { CSV_MODAL_TYPES } from 'utils/admin-csv';
import { showSuccessToast } from 'shared-components/BaseToast/Toast';
import CSVModal from 'shared-components/CSVModal/CSVModal';
import BaseModal from 'shared-components/BaseModal/Modal';
import CloseButton from 'shared-components/CloseButton/CloseButton';
import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import styles from './ProductCatalogModal.module.css';

const ProductCatalogModal = ({
  getProducts,
  baseModalOpen,
  setBaseModalOpen,
  setProductsCreatedInBulk,
}) => {
  const [csvModalOpen, setCsvModalOpen] = useState(null);
  const closeCsvModal = () => setCsvModalOpen(null);
  const handleUploadSuccess = ({ value }) => {
    if (csvModalOpen === CSV_MODAL_TYPES.editProducts) {
      // bulk editing products
      showSuccessToast(
        'Update Successful',
        'All changes were successfully saved.'
      );
    } else if (csvModalOpen === CSV_MODAL_TYPES.addProducts) {
      // bulk creating products
      showSuccessToast(
        'Product(s) Successfully Created',
        'Successfully uploaded products to the Product Catalog.'
      );
      setProductsCreatedInBulk(value); // allow admins to download a CSV
    } else if (csvModalOpen === CSV_MODAL_TYPES.updateVariantDescriptors) {
      // bulk creating/editing variant descriptors
      showSuccessToast(
        'Variant Descriptors Successfully Updated',
        'Successfully updated variant descriptors in the Product Catalog.'
      );
    }
  };

  const handleModal = (modalType) => {
    setCsvModalOpen(modalType);
    setBaseModalOpen(null);
  };

  return (
    <>
      <CSVModal
        type={csvModalOpen}
        title="Bulk Upload Products"
        onClickClose={closeCsvModal}
        updateData={getProducts}
        onUploadSuccess={handleUploadSuccess}
      />
      <BaseModal isOpen={!!baseModalOpen}>
        <div className={styles.modal}>
          <CloseButton onClick={() => setBaseModalOpen(null)} />
          <h3>Are you editing variant descriptors?</h3>
          <div className={styles.buttonContainer}>
            <Button
              buttonType={BUTTON_TYPES.TERTIARY_INVERSE}
              onClick={() => handleModal(baseModalOpen)}
            >
              No
            </Button>
            <Button
              buttonType={BUTTON_TYPES.TERTIARY}
              onClick={() => {
                handleModal(CSV_MODAL_TYPES.updateVariantDescriptors);
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </BaseModal>
    </>
  );
};

ProductCatalogModal.propTypes = {
  getProducts: PropTypes.func.isRequired,
  baseModalOpen: PropTypes.string,
  setBaseModalOpen: PropTypes.func.isRequired,
  setProductsCreatedInBulk: PropTypes.func.isRequired,
};

ProductCatalogModal.defaultProps = {
  baseModalOpen: null,
};

export default ProductCatalogModal;
